<template>
  <b-card class="mb-2 pb-4">
    <b-row class="mb-2">
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" @click="modalAccount()" class="float-right btn-custom"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
    </b-row>
    <div class="border-bottom"></div>

    <!-- search box filter -->
    <b-row>
      <b-col md="12" style="font-size: 14px; height: 100vh;">
        <b-card no-body>
          <tree-view></tree-view>
          <!-- <b-tabs small card >
          <b-tab v-for="title in listAccount" :key="title.uuid" :title="title.journalAccountName">
            <div v-if="title.journalAccountName">
            </div>
          </b-tab>
          <template #tabs-end>
          <b-nav-item role="presentation" @click="modalAccount()"><b class="text-primary">+</b></b-nav-item>
        </template>
        </b-tabs> -->
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <!-- <b-tree-view :data="listAccount" nodeKeyProp="account_list"></b-tree-view> -->
    </b-row>
    <!-- end search -->
    <!-- end table -->

    <!-- =============== MODAL ============================== -->
    <b-modal id="bv-modal-account" hide-footer>
      <template v-slot:modal-title>
        <h5 class="text-transform text-center">Add Account</h5>
      </template>
      <form v-on:submit.prevent="addAccount()">
        <div class="d-block">
          <b-row class="mt-2">
            <b-col md="4">
              <label for="" class="labels">Sumber</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <div
                class="form-group"
                v-bind:class="errors.has('journalAccountType') ? 'has-error' : ''"
              >
                <b-form-group>
                  <b-form-radio v-model="code.sumber" name="some" value="H">Header</b-form-radio>
                  <b-form-radio v-model="code.sumber" name="some" value="SH"
                    >Sub Header</b-form-radio
                  >
                  <!-- <b-form-radio v-model="formModal.journalAccountType" name="some-radios" value="D">Detail</b-form-radio> -->
                </b-form-group>
                <p v-if="errors.has('journalAccountType') !== null"></p>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="4">
              <label for="" class="labels">Tipe Perkiraan *</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <div
                class="form-group"
                v-bind:class="errors.has('journalAccountType') ? 'has-error' : ''"
              >
                <b-form-group>
                  <b-form-radio v-model="formModal.journalAccountType" name="some-radios" value="H"
                    >Header</b-form-radio
                  >
                  <b-form-radio v-model="formModal.journalAccountType" name="some-radios" value="SH"
                    >Sub Header</b-form-radio
                  >
                  <b-form-radio v-model="formModal.journalAccountType" name="some-radios" value="D"
                    >Detail</b-form-radio
                  >
                </b-form-group>
                <p v-if="errors.has('journalAccountType') !== null"></p>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col md="4">
              <label for="" class="labels">Kelompok</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <b-form-select
                v-model="formModal.journalAccount"
                type="text"
                :options="group"
              ></b-form-select>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="4">
              <label for="" class="labels">Kode Perkiraan *</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <b-form-input
                type="text"
                v-model="formModal.journalAccountCode"
                placeholder="Code account"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="4">
              <label for="" class="labels">Nama *</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <b-form-input
                required
                v-model="formModal.journalAccountName"
                type="text"
                placeholder="Account name"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="4">
              <label for="" class="labels">KAS/BANK</label>
            </b-col>
            <b-col md="1"></b-col>
            <b-col md="7">
              <b-form-checkbox
                id="checkbox-1"
                v-model="formModal.isBank"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
              >
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>
        <b-row>
        <b-col md="6">
        <button class="mt-4 btn btn-outline-warning" @click="$bvModal.hide('bv-modal-account')">
          <font-awesome-icon icon="times"></font-awesome-icon> Cancel
        </button> 
        </b-col>
        <b-col md="6">
        <div v-if="loadingButton" class="float-right mt-4">
          <b-button variant="warning" disabled>
            <b-spinner small type="grow"></b-spinner>
            Loading...
          </b-button>
        </div>
        <div v-else>
          <b-button
            variant="primary"
            class="btn-back float-right mt-4"
            type="submit"
            ><font-awesome-icon icon="save"></font-awesome-icon>
            Save
          </b-button>
        </div>   
        </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
// import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TreeView from './TreeView.vue';
// import PaginatedTable from '../../../components/PaginatedTable.vue';
// import { bTreeView } from 'bootstrap-vue-treeview'

export default {
  name: 'report-index',

  components: {
    TreeView,
    // DatePicker,
    // bTreeView
  },
  props: {
    data: {
      type: Array,
    },
  },

  data() {
    return {
      loadingButton: false,
      isOpen: false,
      isOpenDetail: false,
      apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
      },
      code: {
        sumber: '',
      },
      listAccount: [],
      valueAccounttype: '',
      formModal: {
        journalAccountType: '',
        journalAccountCode: '',
        journalAccountName: '',
        isBank: 0,
        journalAccount: '',
      },
      model: {},
      group: [],

      columns: [],
      tableFilter: {},
      list: [],
    };
  },

  watch: {
    'code.sumber': function(value) {
      if (value) this.getJournalAccount(value);
    },
  },

  mounted() {
    /** call function for get data from API */
    this.getJournalAccount();
    this.getDataAccount();
  },

  methods: {
    newTab() {
      this.tabs.push(this.tabCounter++);
    },
    /**
     * fetch journal account from server
     *
     */

    getJournalAccount(sumber) {
      this.$http
        .get(this.apiUrl.account + '?journalAccountType=' + sumber)
        .then((response) => {
          this.group = [];
          this.listAccount = response.data._embedded.journal_account;
          response.data._embedded.journal_account.forEach((data) => {
            this.group.push({
              value: data.uuid,
              text: data.journalAccountCode + ' - ' + data.journalAccountName,
            });
            console.log('group:', this.group);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDataAccount() {
      this.$http
        .get(this.apiUrl.account + '?journalAccountType=H')
        .then((response) => {
          this.listAccount = [];
          this.listAccount = response.data._embedded.journal_account;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * send data to server
     */

    addAccount() {
      this.loadingButton = true;
      this.$validator
        .validateAll()
        .then((res) => {
          if (res) {
            let formData = new FormData();
            formData.append('journalAccount', this.formModal.journalAccount);
            formData.append('journalAccountType', this.formModal.journalAccountType);
            formData.append('journalAccountCode', this.formModal.journalAccountCode);
            formData.append('journalAccountName', this.formModal.journalAccountName);
            formData.append('isBank', this.formModal.isBank);
            this.$http.post(this.apiUrl.account, formData).then(() => {
              this.$store.dispatch('notification/success', 'Account has been Added');
              this.$bvModal.hide('bv-modal-account');
              this.getDataAccount();
              this.loadingButton = false;
              window.location.reload();
            });
          } else {
            //
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    modalAccount() {
      this.$bvModal.show('bv-modal-account');
    },

    /** ===============function tree ================== */
    toggleHeader(uuid) {
      if (uuid !== null) this.isOpen = !this.isOpen;
    },

    clearFilter() {
      this.tableFilter.customer_name = null;
      this.tableFilter.statusReceipt = null;
      this.tableFilter.number = null;
      this.tableFilter.date = null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm');
      } else {
        return '-';
      }
    },

    /** colores status  */
    getStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Resolved':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
  },
};
</script>
<style scoped>
ul,
#myUL {
  list-style-type: none;
}

/* Remove margins and padding from the parent ul */
#myUL {
  margin: 0;
  padding: 0;
}

/* Style the caret/arrow */
.caret {
  cursor: pointer;
  user-select: none; /* Prevent text selection */
}

/* Create the caret/arrow with a unicode, and style it */
/* .caret::before {
  content: "\25B6";
  color: black;
  display: inline-block;
  margin-right: 6px;
} */

/* Rotate the caret/arrow icon when clicked on (using JavaScript) */
.caret-down::before {
  transform: rotate(90deg);
}

/* Hide the nested list */
/* .nested {
  display: none;
} */

/* Show the nested list when the user clicks on the caret/arrow (with JavaScript) */
.active {
  display: block;
}
</style>
